import { useState, useEffect } from "react";
import type { ActionControl, DistrictWindow } from "@/types/GlobalState";

interface ProcessedWindows {
    intentToReturn: ActionControl | null;
    parentOffer: ActionControl | null;
    parentRequest: ActionControl | null;
    parentRequestRound2: ActionControl | null;
    windowsReady: boolean;
}

export const useOpenEnrollmentWindows = (
    oeActionControls: ActionControl[] | undefined,
    oeDistrictWindows: DistrictWindow[] | undefined
): ProcessedWindows => {
    const [processedWindows, setProcessedWindows] = useState<ProcessedWindows>({
        intentToReturn: null,
        parentOffer: null,
        parentRequest: null,
        parentRequestRound2: null,
        windowsReady: false
    });

    useEffect(() => {
        if (!oeActionControls || !oeDistrictWindows || oeDistrictWindows.length < 2) {
            setProcessedWindows((prev) => ({ ...prev, windowsReady: false }));
            return;
        }

        try {
            const intent = oeActionControls.find((obj) => obj.action === "INTENT_TO_RETURN_FORM") ?? null;

            const round1ActionControls = oeActionControls.filter(
                (obj) => Number.parseInt(obj.differentiator, 10) === Number.parseInt(oeDistrictWindows[0].key, 10)
            );
            const round2ActionControls = oeActionControls.filter(
                (obj) => Number.parseInt(obj.differentiator, 10) === Number.parseInt(oeDistrictWindows[1].key, 10)
            );

            const parentOffer = round1ActionControls.find((obj) => obj.action === "PARENT_OFFER") ?? null;
            const parentRequest = round1ActionControls.find((obj) => obj.action === "PARENT_REQUEST") ?? null;
            const parentRequestRound2 = round2ActionControls.find((obj) => obj.action === "PARENT_REQUEST") ?? null;

            setProcessedWindows({
                intentToReturn: intent,
                parentOffer,
                parentRequest,
                parentRequestRound2,
                windowsReady: true
            });
        } catch (error) {
            console.error("Unable to set Open Enrollment windows:\n", error);
            setProcessedWindows((prev) => ({ ...prev, windowsReady: false }));
        }
    }, [oeActionControls, oeDistrictWindows]);

    return processedWindows;
};
